<template>
  <div class="container clinic-bank-orders">
    <clinic-show-bank-order ref="showorder" @submit="loadOrders()"></clinic-show-bank-order>
    <!-- TITLE -->
    <div class="row mb-3" style="margin-top: 40px">
      <div class="col">
        <h1 class="clinic-bank-orders__title">REMESAS</h1>
      </div>
    </div>
    <!-- FILTERS -->
    <div class="row">
      <template v-if="show_clinic_selector">
        <div class="col-sm-2">
          <select id="clinic_payments_clinic_id" v-model="clinic_id" class="custom-select">
            <option :value="null">Todas</option>
            <option v-for="(name, id) in clinics" :key="id" :value="id">
              {{ name }}
            </option>
          </select>
          <label for="clinic_payments_clinic_id" class="wabident-info">Clínica</label>
        </div>
      </template>

      <div class="col-sm-2">
        <select id="clinic_bank_orders_period" v-model="period" class="custom-select">
          <option value="week">Esta semana</option>
          <option value="week_prior">Semana pasada</option>
          <option value="month">Este mes</option>
          <option value="month_prior">Mes pasado</option>
          <option value="trimester">Este trimestre</option>
          <option value="trimester_prior">Trimestre pasado</option>
          <option value="year">Este año</option>
          <option value="past_year">Año pasado</option>
          <option value="custom">Personalizado</option>
        </select>
        <label for="clinic_bank_orders_period" class="wabident-info">Periodo</label>
      </div>

      <transition name="fade">
        <div class="col-sm-2" v-if="period == 'custom'">
          <input v-model="date_from" id="clinic_bank_orders_date_from" type="date" class="form-control" />
          <label class="wabident-info" for="clinic_bank_orders_date_from">Desde:</label>
        </div>
      </transition>

      <transition name="fade">
        <div class="col-sm-2" v-if="period == 'custom'">
          <input v-model="date_to" id="clinic_bank_orders_date_to" type="date" class="form-control" />
          <label class="wabident-info" for="clinic_bank_orders_date_to">Hasta:</label>
        </div>
      </transition>
    </div>
    <!-- LIST -->
    <div class="row my-3" v-if="has_results">
      <div class="col-md-12">
        <table class="table table-search-results text-center" valign="middle">
          <thead>
            <tr>
              <th>CODIGO</th>
              <th>F. CREACION</th>
              <th>F. PAGO</th>
              <th>PAGOS</th>
              <th>ESTADO</th>
              <th>ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in bank_orders.data" :key="order.id">
              <!-- ID -->
              <td>{{ order.id }}</td>
              <!-- CREATED_AT -->
              <td>{{ formatDate(order.created_at) }}</td>
              <!-- PAY_DATE -->
              <td>{{ formatDate(order.pay_date) }}</td>
              <!-- TREATMENTS -->
              <td>{{ order.payments.length }}</td>
              <!-- STATUS -->
              <td>{{ order_statuses[order.status] }}</td>
              <!-- ACTIONS -->
              <td>
                <button class="btn btn-wabident-round mx-1" @click="editOrder(order)">
                  <i class="fas fa-edit"></i> Editar
                </button>

                <button @click="downloadXML(order)" v-if="order.status != 'invalid'" class="btn btn-wabident-round mx-1"
                  target="_blank">
                  <i class="fas fa-download"></i> XML
                </button>

                <button @click="downloadPDF(order)" v-if="order.status != 'invalid'" class="btn btn-wabident-round mx-1"
                  target="_blank">
                  <i class="fas fa-download"></i> PDF
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- PAGINATION -->
    <div class="row" v-if="has_results">
      <div class="col-md-12">
        <data-pagination @gotopage="loadOrders" :page="bank_orders.current_page"
          :total="bank_orders.last_page"></data-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clinic_id: null,
      date_from: null,
      date_to: null,
      period: 'week',
      bank_orders: null,
      order_statuses: {
        invalid: 'Necesita corrección',
        xml_pending: 'Pend. Descarga',
        payment_pending: 'Pend. Pago',
        paid: 'Pagada',
      }
    };
  },
  watch: {
    clinic_id(val) {
      this.loadOrders(1);
    },
    date_from(val) {
      this.loadOrders(1);
    },
    date_to(val) {
      this.loadOrders(1);
    },
    period(val) {
      this.loadOrders(1);
    }
  },
  computed: {
    has_results() {
      return this.bank_orders && this.bank_orders.data;
    },
    clinics() {
      if (!this.clinic) return [];
      return this.clinic.clinic_names;
    },
    show_clinic_selector() {
      return Object.keys(this.clinics).length > 1;
    },
    ...mapGetters(['clinic', 'msgwindow', 'errorwindow'])
  },
  methods: {
    downloadXML(order) {
      const uri = `/bank_orders/${order.id}/xml`;
      window.open(uri);
      setTimeout(() => {
        this.loadOrders(1);
      }, 1000);
    },
    downloadPDF(order) {
      const uri = `/bank_orders/${order.id}/pdf`;
      window.open(uri);
    },
    formatDate(date) {
      return WabiDent.fmtDate(date);
    },
    loadOrders(page = 1) {
      axios
        .get("/bank_orders", {
          params: {
            page: page,
            clinic_id: this.clinic_id,
            period: this.period,
            date_from: this.date_from,
            date_to: this.date_to,
          },
        })
        .then((response) => {
          this.bank_orders = response.data;
        })
        .catch((error) => {
          console.log("[ERR] loadOrders:", error);
        });
    },
    editOrder(order) {
      this.$refs.showorder.show(order);
    }
  },
  mounted() {
    this.loadOrders(1);
  }
};
</script>

<style lang="scss">
.clinic-bank-orders {}
</style>
